import React from "react";
import {
	Avatar,
	Box,
	Container,
	Flex,
	Heading,
	IconButton,
	Img,
	Link,
	ListItem,
	Text,
	UnorderedList,
} from "@chakra-ui/react";
import { FaLinkedin } from "react-icons/fa";

const TheContextInvestBlog: React.FC = () => (
	<>
		<Flex
			flexDirection="column"
			overflow="hidden"
			justify="center"
			height="100%"
			py={{ xs: "30px", sm: "40px", md: "60px", lg: "80px" }}
			h="100%"
			minH={{ xs: "400px", lg: "400px" }}
			maxH={{ xs: "400px", lg: "400px" }}
			pos="relative"
		>
			<Img
				pos="absolute"
				objectFit="cover"
				src="/webp/theContext-bg.webp"
				alt="members-hero"
				height="100%"
				width="100%"
			/>
			<Box
				bg="linear-gradient(78.35deg, rgba(13, 96, 81, 0.8) 18.38%, rgba(83, 92, 143, 0.8) 86.05%)"
				pos="absolute"
				height="100%"
				width="100%"
				opacity="0.7"
			/>
			<Container
				display="flex"
				as="section"
				maxW="container.xl"
				position="relative"
				zIndex="1"
				flexDir={{ xs: "column", md: "row" }}
				columnGap="24px"
				rowGap="30px"
				alignItems={{ xs: "flex-start", md: "flex-start" }}
				px={{ xs: "14px", sm: "28px", md: "45px", lg: "60px", xl: "inherit" }}
			>
				<Flex flexDir="column" rowGap="16px">
					<Heading
						color="white"
						fontSize={{ xs: "36px", sm: "42px", lg: "64px" }}
						fontWeight="800"
						lineHeight={{ xs: "35px", lg: "83px" }}
					>
						#TheContext
					</Heading>
					{/* <Heading
            color="white"
            fontSize={{ xs: '28px', sm: '34px' }}
            fontWeight="500"
            lineHeight="32px"
          >
            - By IVCA
          </Heading> */}
				</Flex>
				<Box
					w="1.5px"
					h={{ md: "200px", lg: "300px", xl: "230px" }}
					bgColor="white"
					display={{ xs: "none", md: "block" }}
				/>
				<Box
					w={{ xs: "70%", sm: "60%" }}
					h="1.5px"
					bgColor="white"
					display={{ xs: "block", md: "none" }}
				/>
				<Flex flexDir="column" rowGap="8px">
					<Heading
						as="h1"
						mb={{ xs: "10px", md: "20px" }}
						variant="reportCardTitle"
						fontSize={{ xs: "27px", sm: "29px", md: "32px", lg: "54px" }}
						color="white"
						lineHeight={{ xs: "36px", sm: "40px", md: "46px", lg: "70.2px" }}
					>
						Investing for a Climate-Resilient World: Introducing the IVCA Green
						Future Series
					</Heading>
					<Text
						fontSize={{ xs: "18px", sm: "18px", md: "20px", lg: "22px" }}
						fontWeight="600"
						color="white"
						lineHeight="28px"
					>
						Aakriti Bamniyal
					</Text>
					<Text
						fontSize={{ xs: "18px", sm: "18px", md: "20px", lg: "22px" }}
						fontWeight="600"
						color="white"
						lineHeight="28px"
					>
						Sumeet Shetty
					</Text>
				</Flex>
			</Container>
		</Flex>
		<Container maxW="container.xl" pb="80px" pt="40px">
			<Flex
				flexDir={{ xs: "column-reverse", md: "row" }}
				px={{ xs: "8px", md: "0px" }}
			>
				<Flex
					w={{ xs: "100%", md: "27%" }}
					mt={{ xs: "32px", md: "0px" }}
					flexDir="column"
					rowGap="16px"
					mr={{ xs: "0px", md: "40px" }}
					ml={{ xs: "0px", sm: "10px" }}
					mb={{ xs: "16px", md: "8px" }}
				>
					<Heading
						fontSize="22px"
						lineHeight="22px"
						textAlign={{ xs: "center", sm: "left" }}
					>
						Follow the Authors
					</Heading>
					<Box
						w="100%"
						h="1.5px"
						bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
						my="8px"
					/>
					{[
						{
							name: "Aakriti Bamniyal",
							position: "Sr. Vice President, IVCA",
							linkedin:
								"https://www.linkedin.com/in/aakriti-bamniyal-b6505944/",
							image:
								"https://static.levocdn.com/WGLBUT82/7079702270960707525.png",
						},
						{
							name: "Sumeet Shetty",
							position: "Asst. Vice President, IVCA",
							linkedin: "https://www.linkedin.com/in/sumeet-shetty-3577b737/",
							image:
								"https://static.levocdn.com/WGLBUT82/7079702269919135175.png",
						},
					].map((item, index) => (
						<Flex
							key={index}
							flexDir={{ xs: "column", sm: "row", md: "column" }}
							columnGap="20px"
							rowGap="16px"
						>
							<Flex
								flexDir="column"
								alignItems={{ xs: "center", sm: "flex-start" }}
								rowGap="8px"
							>
								<Box boxSize="95px" borderRadius="50%" overflow="hidden">
									<Avatar
										name={item.name}
										w="100%"
										h="100%"
										src={item.image}
										objectFit="cover"
									/>
								</Box>
								<Flex flexDir="column" rowGap="4px">
									<Heading
										variant="blogQuestion"
										textAlign={{ xs: "center", sm: "left" }}
									>
										{item.name}
									</Heading>
									<Text
										variant="blogAnswer"
										textAlign={{ xs: "center", sm: "left" }}
										fontStyle="italic"
									>
										{item.position}
									</Text>
								</Flex>
								<Flex
									columnGap={{ xs: "4px", md: "16px" }}
									justifyContent={{ xs: "center", sm: "flex-start" }}
									transform={{ xs: "translateX(12px)", sm: "none" }}
								>
									<Box alignSelf="center">
										<Link href={item.linkedin} target="_blank">
											<IconButton
												aria-label="linkedin"
												icon={
													<FaLinkedin
														size="28px"
														color="rgba(100, 100, 140, 0.6)"
													/>
												}
												variant="unstyled"
												cursor="pointer"
											/>
										</Link>
									</Box>
								</Flex>
							</Flex>
						</Flex>
					))}
				</Flex>

				<Box w={{ xs: "100%", md: "73%" }}>
					<Text variant="blogAnswer" mb="20px">
						The climate crisis is accelerating at a faster pace than anticipated
						by global leaders. It also presents with a critical moment now for a
						collective climate action on providing solutions, while contributing
						to growth and ensuring inclusive development. India, in particular,
						has made a significant promise to cut its emissions to net zero by
						2070, marking a pivotal milestone in the battle against climate
						change. In recent years, the role of private equity (PE) and impact
						investing in driving positive change has become increasingly
						crucial. Trillions of dollars are being directed towards renewable
						energy projects, grid infrastructure, energy storage solutions, and
						electric mobility. Moreover, a considerable portion of these
						investments has been allocated to the development of next-generation
						technologies that propel transition towards a low-carbon economy.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						IVCA recognizes the significance of sustainable investment practices
						and thereby, introducing the{" "}
						<Text as="span" fontWeight="700">
							&apos;IVCA Green Future Series&apos;
						</Text>{" "}
						to address and widely advocate climate and sustainability issues.
						This monthly series will feature discussions on various topics, with
						the maiden edition focusing on{" "}
						<Text as="span" fontWeight="700">
							&apos;Delivering Clean Air: Mitigating Air Pollution.&apos;
						</Text>{" "}
						The conversations featured in this series hope to contribute towards
						creating awareness and pave the way for a climate-resilient world.
						The first phase of this series will host six webinars. Let’s see,
						what one can look forward to from this series.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						<Text as="span" fontWeight="700">
							Hear from esteemed Speakers and Industry experts:
						</Text>{" "}
						The inaugural session of the IVCA Green Future Series will witness
						the esteemed presence of Shri Jayant Sinha, Chairperson of the
						Standing Committee for Finance, Parliament of India, and BJP Lok
						Sabha Member of Parliament from Hazaribagh, Jharkhand. His keynote
						address will shed light on the importance of mitigating air
						pollution and the role of finance and investment in driving
						sustainable solutions. Following this address, an engaging panel
						discussion will take place, featuring a diverse range of experts
						including investors, academicians, and start-up founders. Together,
						they will delve into strategies and innovations aimed at delivering
						clean air and combating air pollution.
					</Text>
					<Text variant="blogAnswer" pb="20px" fontWeight="700">
						5 Key Areas of Discussion on Climate Action to be featured in IVCA
						Green Future Series:
					</Text>
					<UnorderedList>
						<ListItem mb="4px">
							<Text fontWeight="bold" variant="blogAnswer" pl={{ md: "12px" }}>
								Electric Mobility
							</Text>
						</ListItem>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							The Indian automobile sector contributes &gt; 7% of the
							country&apos;s GDP. With a population of 1.4Bn and growing, India
							is expected to have 300 million additional cars on the road by
							2040 which will result in an increase in the oil consumption of
							four million barrels per day. This signifies that electrification
							of passenger transport is now an important priority. The
							e-mobility market in India is projected to grow at an average
							annual rate of 49% between 2021 and 2030 with India being on road
							to become the largest EV market with a total investment
							opportunity of more than US$ 200 billion over the next 8-10 years.
						</Text>
						<ListItem mb="4px">
							<Text fontWeight="bold" variant="blogAnswer" pl={{ md: "12px" }}>
								Climate Data & Analytics
							</Text>
						</ListItem>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							UNICEF’s 2021 report - ‘The Climate Crisis Is a Child Rights
							Crisis,’ ranks India 26th out of 163 ranked countries which
							implies that Indian children are among the most ‘at-risk’ to the
							impacts of climate change. On an average the Indian subcontinent
							has observed an increase of 0.7°C since 1900. Therefore, as the
							impact of climate change intensifies, the volume of data produced
							and managed by the emerging climate prediction start-ups will
							continue to grow and so will the stakes. Will be interesting to
							learn more on the predictive models and advanced data analytics
							start-ups in India are applying to mitigate the risk of climate
							change.
						</Text>
						<ListItem mb="4px">
							<Text fontWeight="bold" variant="blogAnswer" pl={{ md: "12px" }}>
								Single-Use Plastic
							</Text>
						</ListItem>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							According to government estimates, India generates approximately
							3.5 million tonnes of plastic waste annually. Single-use plastics
							widely affect both terrestrial and aquatic ecosystems. Many
							start-ups and investors are trying to figure our innovative
							methods of doing away with single-use plastics, reduce waste and
							boost recycling rates by using bamboo and bamboo-based packaging
							products as alternatives. Will be good to learn more from such
							innovative use cases.
						</Text>
						<ListItem mb="4px">
							<Text fontWeight="bold" variant="blogAnswer" pl={{ md: "12px" }}>
								Regenerative Agriculture
							</Text>
						</ListItem>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							The situation in Indian agricultural farms is becoming
							increasingly critical, as approximately 29% of India&apos;s total
							land area has been degraded. This underscores the significant
							hurdle that India must overcome to fulfil its goal of attaining
							land degradation neutrality by 2030. This comes at a time when
							India is facing acute shortage and scarcity of fresh water sources
							in many states and union territories.
						</Text>
						<ListItem mb="4px">
							<Text fontWeight="bold" variant="blogAnswer" pl={{ md: "12px" }}>
								Waste Recycling
							</Text>
						</ListItem>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							Rapid urbanization and consumerism have called for the urgent
							requirement for waste processing and management in India. Backed
							by regulatory frameworks such as the Swachh Bharat Mission and
							fuelled by strong demand from both domestic and global companies’
							stakeholders, innovative companies in India are poised to make
							substantial environmental and social progress while also driving
							economic growth.
						</Text>
					</UnorderedList>
					<Text variant="blogAnswer" pb="20px">
						As the world faces unprecedented environmental challenges, the IVCA
						Green Future Series aims to inspire and drive investment in
						innovative solutions that can contribute to a greener, more
						sustainable future. Join us in this collective effort to create a
						climate-resilient world for generations to come. To register please{" "}
						<Link
							as="a"
							href="https://forms.gle/2pprjpyLeYRCyetB6"
							target="_blank"
							style={{ color: "blue", textDecoration: "underline" }}
						>
							click here
						</Link>{" "}
						. If you have any questions or require further information, please
						reach out to us at{" "}
						<Link
							as="a"
							href="mailto:aakriti@ivca.in"
							target="_blank"
							style={{ color: "blue", textDecoration: "underline" }}
						>
							aakriti@ivca.in
						</Link>{" "}
						or{" "}
						<Link
							as="a"
							href="mailto:sumeet@ivca.in"
							target="_blank"
							style={{ color: "blue", textDecoration: "underline" }}
						>
							sumeet@ivca.in
						</Link>{" "}
						.
					</Text>
				</Box>
			</Flex>
			<Box w="100%" h="1.5px" mt="16px" mb="8px" bgColor="gray.700" />
			<Text variant="blogAnswer" fontStyle="italic" p="12px 12px 0px">
				<Heading variant="blogQuestion" fontStyle="normal" as="span">
					#TheContext by IVCA{" "}
				</Heading>
				– features opinion makers from the alternate investing industry with
				strong focus on India as investment destination. Watch this space for
				viewpoints on investment themes, emerging trends, economic analysis and
				latest industry insights.
			</Text>
			<Heading
				variant="blogQuestion"
				lineHeight="30px"
				pt="16px"
				fontStyle="italic"
				p="12px 12px 0px"
			>
				Content in this section is curated by team IVCA. To share feedback,
				connect with &nbsp;
				<Link
					href="mailto:paromita.sinha@ivca.in"
					target="_blank"
					style={{ color: "blue", textDecoration: "underline" }}
				>
					paromita.sinha@ivca.in
				</Link>
			</Heading>
		</Container>
	</>
);

export default TheContextInvestBlog;
